export class SaveChat {
  fromUserId: number;
  toUserId: number;
  messages: SaveChatMessage[];
}

export class SaveChatMessage {
  message: string;
}

export class SendChatCommunication {
  toPatientIds: number[] = [];
  practitionerId: number;
  employerId: number;
  subject: string;
  content: string;
  sms: boolean;
  email: boolean;
}
